import React from 'react';
import GraphGrid from './GraphGrid';
import { nextLabel } from '../gameFlow';

/**
 * LA PAGE DE TYPE `score` : un titre, des graphiques, un bouton.
 *
 * Elle ne décide plus de rien : `content.list_graph` dit quoi afficher et
 * GraphGrid le monte. Un long bloc commenté vivait ici, qui composait les mêmes
 * graphes à la main avant que `list_graph` n'existe — il a été retiré avec les
 * variables qu'il seul lisait (`dashboard_type`, `additional_graph`), qui
 * restent dans les documents sans être lues par personne.
 *
 * La coque est celle du tableau de bord (`.board-*`, App.css), partagée avec
 * les trois bilans de fin : ces écrans sont les mêmes — projetés, commentés,
 * lus de loin — et n'avaient aucune raison de ne pas se ressembler.
 */
const ScoreBoard = ({
  pageData,
  gameStatus,
  onDecisionSelect,
  displayButton = true,
  endsGame = false,
  editMode = false,
  onEditGraphItem,
  onAddGraphItem,
}) => {
  const scores = gameStatus.score_dic;

  const handleNextClick = () => {
    onDecisionSelect({
      page_id: pageData._id,
      page_type: 'score',
    });
  };

  if (!scores) {
    return <div className="score-board-loading">Chargement des scores…</div>;
  }

  return (
    <div className="page-general-container">
      <div className='page-general-background-color'></div>

      <div className='page-general-background-hero' style={{ backgroundImage: `url(/img/bgrille-m.svg)` }}>
          <div className='page-general-background-image' style={{ backgroundImage: `url(${pageData.content.background_image_url})` }}></div>
      </div>

      <div className='page-main-content'>
        <div className="board-page">
          {/* Le titre de la page plutôt qu'un libellé en dur : « Les résultats
              de la phase » s'affichait au milieu d'un atelier Compte-Gouttes,
              qui n'a pas de phases. Le repli garde l'ancien texte. */}
          <header className="board-head">
            <h1 className="board-title">{pageData.title || 'Les résultats de la phase'}</h1>
            {pageData.description && (
              <p className="board-subtitle">{pageData.description}</p>
            )}
          </header>

          <GraphGrid
            listGraph={pageData.content.list_graph}
            gameStatus={gameStatus}
            editMode={editMode}
            onEditGraphItem={onEditGraphItem}
            onAddGraphItem={onAddGraphItem}
          />

          {displayButton && !editMode && (
            <div className="board-actions">
              <button className='blue-button' onClick={handleNextClick}>{nextLabel(endsGame)}</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScoreBoard;
